"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WstMTRGOracle__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_wstMTRG",
                type: "address",
            },
            {
                internalType: "address",
                name: "_mtrgFeed",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_feedId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "feedId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "getEmaPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "uint64",
                        name: "conf",
                        type: "uint64",
                    },
                    {
                        internalType: "int32",
                        name: "expo",
                        type: "int32",
                    },
                    {
                        internalType: "uint256",
                        name: "publishTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct PythStructs.Price",
                name: "price",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "age",
                type: "uint256",
            },
        ],
        name: "getEmaPriceNoOlderThan",
        outputs: [
            {
                components: [
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "uint64",
                        name: "conf",
                        type: "uint64",
                    },
                    {
                        internalType: "int32",
                        name: "expo",
                        type: "int32",
                    },
                    {
                        internalType: "uint256",
                        name: "publishTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct PythStructs.Price",
                name: "price",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "getEmaPriceUnsafe",
        outputs: [
            {
                components: [
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "uint64",
                        name: "conf",
                        type: "uint64",
                    },
                    {
                        internalType: "int32",
                        name: "expo",
                        type: "int32",
                    },
                    {
                        internalType: "uint256",
                        name: "publishTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct PythStructs.Price",
                name: "price",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "getPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "uint64",
                        name: "conf",
                        type: "uint64",
                    },
                    {
                        internalType: "int32",
                        name: "expo",
                        type: "int32",
                    },
                    {
                        internalType: "uint256",
                        name: "publishTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct PythStructs.Price",
                name: "price",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "age",
                type: "uint256",
            },
        ],
        name: "getPriceNoOlderThan",
        outputs: [
            {
                components: [
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "uint64",
                        name: "conf",
                        type: "uint64",
                    },
                    {
                        internalType: "int32",
                        name: "expo",
                        type: "int32",
                    },
                    {
                        internalType: "uint256",
                        name: "publishTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct PythStructs.Price",
                name: "price",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "getPriceUnsafe",
        outputs: [
            {
                components: [
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "uint64",
                        name: "conf",
                        type: "uint64",
                    },
                    {
                        internalType: "int32",
                        name: "expo",
                        type: "int32",
                    },
                    {
                        internalType: "uint256",
                        name: "publishTime",
                        type: "uint256",
                    },
                ],
                internalType: "struct PythStructs.Price",
                name: "price",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getValidTimePeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "validTimePeriod",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mtrgFeed",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wstMTRG",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class WstMTRGOracle__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_wstMTRG, _mtrgFeed, _feedId, overrides) {
        return super.getDeployTransaction(_wstMTRG, _mtrgFeed, _feedId, overrides || {});
    }
    deploy(_wstMTRG, _mtrgFeed, _feedId, overrides) {
        return super.deploy(_wstMTRG, _mtrgFeed, _feedId, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.WstMTRGOracle__factory = WstMTRGOracle__factory;
WstMTRGOracle__factory.bytecode = _bytecode;
WstMTRGOracle__factory.abi = _abi;
//# sourceMappingURL=WstMTRGOracle__factory.js.map